import React from 'react'
import { Dialog, Typography, IconButton } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { useStyles } from './ImageDialog.style'

export const ImageDialog = ({ open, onClose, layoutName, imageLayout }) => {
  const classes = useStyles()

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          position: 'relative',
          background: '#fff',
          overflow: 'hidden'
        }
      }}>
      <div className={classes.titleContainer}>
        <Typography className={classes.layoutName} variant='h4'>
          {layoutName}
        </Typography>
        <IconButton
          aria-label='close'
          onClick={onClose}
          className={classes.button}>
          <Close />
        </IconButton>
      </div>
      <div className={classes.containerImage}>
        <img
          src={imageLayout}
          alt='plany'
          width={700}
          height={500}
          className={classes.image}
        />
      </div>
    </Dialog>
  )
}

export default ImageDialog
